import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  detailedData: [],
  totalSamplers: 0,
  pagination: {
    currentPage: 1,
    pageSize: 10,
    total: 0,
  },
};

const samplingTrackingDetailedSlice = createSlice({
  name: "samplingTrackingDetailed",
  initialState,
  reducers: {
    fetchDetailed: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchDetailedSuccess: (state, action) => {
      const { data } = action.payload;
      state.loading = false;
      state.detailedData = data?.tableData || [];
      state.totalSamplers = data?.totalSamplers || 0;
      state.pagination.total = data?.totalSamplers || 0;
    },
    fetchDetailedFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.detailedData = [];
      state.totalSamplers = 0;
      state.pagination.total = 0;
    },
    // Pagination actions for client-side pagination
    setPagination: (state, action) => {
      const { currentPage, pageSize } = action.payload;
      state.pagination.currentPage = currentPage || state.pagination.currentPage;
      state.pagination.pageSize = pageSize || state.pagination.pageSize;
    },
    setPageSize: (state, action) => {
      state.pagination.pageSize = action.payload;
      state.pagination.currentPage = 1; // Reset to first page when changing page size
    },
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    },
    resetPagination: (state) => {
      state.pagination.currentPage = 1;
      // Keep the same pageSize, don't reset it to 10
    },
  },
});

export const { actions, reducer } = samplingTrackingDetailedSlice;
export const sliceKey = samplingTrackingDetailedSlice.name;
